import { SECTION_QUERY_PARAM } from 'floorplan/pages/native-floorplan/const';
import { useSearchParams } from 'hooks/use-search-params.hook';
import { searchParams as SearchParams } from 'shared/types/search-params';

/**
 * The section the map is filtered to, or null for all of them.
 *
 * Read straight from the url so the map and the filters sheet cannot disagree: the sheet writes the
 * param, the map reads it, and a reload or a shared link keeps the filter.
 */
export const useSelectedSectionUuid = (): string | null => {
  const queryParams = useSearchParams<SearchParams>();
  const value = queryParams[SECTION_QUERY_PARAM];

  // A hand-edited url can repeat the param, which `qs` parses into an array. The type says string,
  // so the check is what makes that true rather than something the callers trip over.
  return typeof value === 'string' && value ? value : null;
};
